import React from 'react';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import { BreakMonthForecast } from './BreakMonthForecast';
import {
  DateTextBox,
  FlexLayout,
  GridLayout,
  SearchLayout,
} from '../../../../components';
import {
  Global,
  TemplateProps,
} from '../../../../constants';

/**
 * 화면
 * @window w_tb_e411w_06
 * @category 고장예방보전관리
 */
export const BreakMonthForecastTemplate: React.FC<TemplateProps<BreakMonthForecast>> = ({
  scope,
}) => (
  <FlexLayout isVertical={true}>
    <SearchLayout size={Global.LAYOUT_SEARCH_HEIGHT_1}>
      <FlexLayout size={200}>
        <span>년도</span>
        <DateTextBox
          value={scope.state.year}
          textAlign="center"
          format="####"
          onChange={(value) => scope.SS({ year: value })}
          onEnter={() => scope.onRetrieveEvent()}
          head={(
            <button
              onClick={() => {
                const date = new Date(`${scope.state.year}-01-01`);
                date.setFullYear(date.getFullYear() - 1);
                scope.setState({ year: date.getFullYear().toString() },
                  () => scope.onRetrieveEvent());
              }}
            >
              <MdKeyboardArrowLeft size={24}/>
            </button>
          )}
          trail={(
            <button
              onClick={() => {
                const date = new Date(`${scope.state.year}-01-01`);
                date.setFullYear(date.getFullYear() + 1);
                scope.setState({ year: date.getFullYear().toString() },
                  () => scope.onRetrieveEvent());
              }}
            >
              <MdKeyboardArrowRight size={24}/>
            </button>
          )}
          isDisabledTrackingStateChange={true}
        elField="year"
        />
      </FlexLayout>
    </SearchLayout>

    <GridLayout
      headerHeight={48}
      ref={scope.grid}
      header={[
        {
          id: 'date',
          text: (
            <FlexLayout isVertical={true}>
              <FlexLayout
                justify="center"
                align="center"
              >
                일자
              </FlexLayout>
              <FlexLayout></FlexLayout>
            </FlexLayout>
          ),
          width: 80,
          render: (x) => (
            <FlexLayout
              justify="center"
              align="center"
            >
              {x.date}
            </FlexLayout>
          ),
          trail: () => (
            <FlexLayout isVertical={true}>
              <FlexLayout>합계</FlexLayout>
              <FlexLayout style={{ color: 'var(--color-violet)' }}>(예측정확도)</FlexLayout>
              <FlexLayout style={{ color: 'var(--color-violet)' }}>{scope.state.accyear_tot}%</FlexLayout>
            </FlexLayout>
          ),
        },
        {
          id: '01',
          text: (
            <FlexLayout isVertical={true}>
              <FlexLayout>
                1월
              </FlexLayout>

              <FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  예측건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  고장건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  차이
                </FlexLayout>
              </FlexLayout>
            </FlexLayout>
          ),
          width: 150,
          render: (x) => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: 'var(--color-green)' }}
              >
                {x.predict01}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
              >
                {x.cnt01}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={x.gap01 === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {x.gap01}
              </FlexLayout>
            </FlexLayout>
          ),
          trail: () => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: '#00FF00' }}
              >
                {scope.state.predict01_tot}
              </FlexLayout>
              <FlexLayout isVertical={true}>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  {scope.state.cnt01_tot}
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="centger"
                  style={{ color: 'var(--color-violet)' }}
                >
                  {scope.state.acc01_tot}%
                </FlexLayout>
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={scope.state.gap01_tot === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {scope.state.gap01_tot}
              </FlexLayout>
            </FlexLayout>
          ),
        },
        {
          id: '02',
          text: (
            <FlexLayout isVertical={true}>
              <FlexLayout>
                2월
              </FlexLayout>

              <FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  예측건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  고장건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  차이
                </FlexLayout>
              </FlexLayout>
            </FlexLayout>
          ),
          width: 150,
          render: (x) => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: 'var(--color-green)' }}
              >
                {x.predict02}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
              >
                {x.cnt02}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={x.gap02 === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {x.gap02}
              </FlexLayout>
            </FlexLayout>
          ),
          trail: () => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: '#00FF00' }}
              >
                {scope.state.predict02_tot}
              </FlexLayout>
              <FlexLayout isVertical={true}>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  {scope.state.cnt02_tot}
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="centger"
                  style={{ color: 'var(--color-violet)' }}
                >
                  {scope.state.acc02_tot}%
                </FlexLayout>
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={scope.state.gap02_tot === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {scope.state.gap02_tot}
              </FlexLayout>
            </FlexLayout>
          ),
        },
        {
          id: '03',
          text: (
            <FlexLayout isVertical={true}>
              <FlexLayout>
                3월
              </FlexLayout>

              <FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  예측건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  고장건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  차이
                </FlexLayout>
              </FlexLayout>
            </FlexLayout>
          ),
          width: 150,
          render: (x) => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: 'var(--color-green)' }}
              >
                {x.predict03}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
              >
                {x.cnt03}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={x.gap03 === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {x.gap03}
              </FlexLayout>
            </FlexLayout>
          ),
          trail: () => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: '#00FF00' }}
              >
                {scope.state.predict03_tot}
              </FlexLayout>
              <FlexLayout isVertical={true}>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  {scope.state.cnt03_tot}
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="centger"
                  style={{ color: 'var(--color-violet)' }}
                >
                  {scope.state.acc03_tot}%
                </FlexLayout>
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={scope.state.gap03_tot === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {scope.state.gap03_tot}
              </FlexLayout>
            </FlexLayout>
          ),
        },
        {
          id: '04',
          text: (
            <FlexLayout isVertical={true}>
              <FlexLayout>
                4월
              </FlexLayout>

              <FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  예측건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  고장건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  차이
                </FlexLayout>
              </FlexLayout>
            </FlexLayout>
          ),
          width: 150,
          render: (x) => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: 'var(--color-green)' }}
              >
                {x.cnt04}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
              >
                {x.cnt04}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={x.gap04 === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {x.gap04}
              </FlexLayout>
            </FlexLayout>
          ),
          trail: () => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: '#00FF00' }}
              >
                {scope.state.predict04_tot}
              </FlexLayout>
              <FlexLayout isVertical={true}>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  {scope.state.cnt04_tot}
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="centger"
                  style={{ color: 'var(--color-violet)' }}
                >
                  {scope.state.acc04_tot}%
                </FlexLayout>
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={scope.state.gap04_tot === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {scope.state.gap04_tot}
              </FlexLayout>
            </FlexLayout>
          ),
        },
        {
          id: '05',
          text: (
            <FlexLayout isVertical={true}>
              <FlexLayout>
                5월
              </FlexLayout>

              <FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  예측건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  고장건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  차이
                </FlexLayout>
              </FlexLayout>
            </FlexLayout>
          ),
          width: 150,
          render: (x) => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: 'var(--color-green)' }}
              >
                {x.predict05}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
              >
                {x.cnt05}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={x.gap05 === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {x.gap05}
              </FlexLayout>
            </FlexLayout>
          ),
          trail: () => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: '#00FF00' }}
              >
                {scope.state.predict05_tot}
              </FlexLayout>
              <FlexLayout isVertical={true}>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  {scope.state.cnt05_tot}
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="centger"
                  style={{ color: 'var(--color-violet)' }}
                >
                  {scope.state.acc05_tot}%
                </FlexLayout>
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={scope.state.gap05_tot === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {scope.state.gap05_tot}
              </FlexLayout>
            </FlexLayout>
          ),
        },
        {
          id: '06',
          text: (
            <FlexLayout isVertical={true}>
              <FlexLayout>
                6월
              </FlexLayout>

              <FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  예측건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  고장건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  차이
                </FlexLayout>
              </FlexLayout>
            </FlexLayout>
          ),
          width: 150,
          render: (x) => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: 'var(--color-green)' }}
              >
                {x.predict06}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
              >
                {x.cnt06}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={x.gap06 === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {x.gap06}
              </FlexLayout>
            </FlexLayout>
          ),
          trail: () => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: '#00FF00' }}
              >
                {scope.state.predict06_tot}
              </FlexLayout>
              <FlexLayout isVertical={true}>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  {scope.state.cnt06_tot}
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="centger"
                  style={{ color: 'var(--color-violet)' }}
                >
                  {scope.state.acc06_tot}%
                </FlexLayout>
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={scope.state.gap06_tot === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {scope.state.gap06_tot}
              </FlexLayout>
            </FlexLayout>
          ),
        },
        {
          id: '07',
          text: (
            <FlexLayout isVertical={true}>
              <FlexLayout>
                7월
              </FlexLayout>

              <FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  예측건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  고장건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  차이
                </FlexLayout>
              </FlexLayout>
            </FlexLayout>
          ),
          width: 150,
          render: (x) => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: 'var(--color-green)' }}
              >
                {x.predict07}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
              >
                {x.cnt07}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={x.gap07 === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {x.gap07}
              </FlexLayout>
            </FlexLayout>
          ),
          trail: () => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: '#00FF00' }}
              >
                {scope.state.predict07_tot}
              </FlexLayout>
              <FlexLayout isVertical={true}>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  {scope.state.cnt07_tot}
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="centger"
                  style={{ color: 'var(--color-violet)' }}
                >
                  {scope.state.acc07_tot}%
                </FlexLayout>
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={scope.state.gap07_tot === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {scope.state.gap07_tot}
              </FlexLayout>
            </FlexLayout>
          ),
        },
        {
          id: '08',
          text: (
            <FlexLayout isVertical={true}>
              <FlexLayout>
                8월
              </FlexLayout>

              <FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  예측건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  고장건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  차이
                </FlexLayout>
              </FlexLayout>
            </FlexLayout>
          ),
          width: 150,
          render: (x) => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: 'var(--color-green)' }}
              >
                {x.predict08}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
              >
                {x.cnt08}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={x.gap08 === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {x.gap08}
              </FlexLayout>
            </FlexLayout>
          ),
          trail: () => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: '#00FF00' }}
              >
                {scope.state.predict08_tot}
              </FlexLayout>
              <FlexLayout isVertical={true}>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  {scope.state.cnt08_tot}
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="centger"
                  style={{ color: 'var(--color-violet)' }}
                >
                  {scope.state.acc08_tot}%
                </FlexLayout>
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={scope.state.gap08_tot === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {scope.state.gap08_tot}
              </FlexLayout>
            </FlexLayout>
          ),
        },
        {
          id: '09',
          text: (
            <FlexLayout isVertical={true}>
              <FlexLayout>
                9월
              </FlexLayout>

              <FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  예측건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  고장건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  차이
                </FlexLayout>
              </FlexLayout>
            </FlexLayout>
          ),
          width: 150,
          render: (x) => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: 'var(--color-green)' }}
              >
                {x.predict09}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
              >
                {x.cnt09}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={x.gap09 === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {x.gap09}
              </FlexLayout>
            </FlexLayout>
          ),
          trail: () => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: '#00FF00' }}
              >
                {scope.state.predict09_tot}
              </FlexLayout>
              <FlexLayout isVertical={true}>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  {scope.state.cnt09_tot}
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="centger"
                  style={{ color: 'var(--color-violet)' }}
                >
                  {scope.state.acc09_tot}%
                </FlexLayout>
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={scope.state.gap09_tot === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {scope.state.gap09_tot}
              </FlexLayout>
            </FlexLayout>
          ),
        },
        {
          id: '10',
          text: (
            <FlexLayout isVertical={true}>
              <FlexLayout>
                10월
              </FlexLayout>

              <FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  예측건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  고장건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  차이
                </FlexLayout>
              </FlexLayout>
            </FlexLayout>
          ),
          width: 150,
          render: (x) => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: 'var(--color-green)' }}
              >
                {x.predict10}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
              >
                {x.cnt10}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={x.gap10 === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {x.gap10}
              </FlexLayout>
            </FlexLayout>
          ),
          trail: () => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: '#00FF00' }}
              >
                {scope.state.predict10_tot}
              </FlexLayout>
              <FlexLayout isVertical={true}>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  {scope.state.cnt10_tot}
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="centger"
                  style={{ color: 'var(--color-violet)' }}
                >
                  {scope.state.acc10_tot}%
                </FlexLayout>
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={scope.state.gap10_tot === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {scope.state.gap10_tot}
              </FlexLayout>
            </FlexLayout>
          ),
        },
        {
          id: '11',
          text: (
            <FlexLayout isVertical={true}>
              <FlexLayout>
                11월
              </FlexLayout>

              <FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  예측건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  고장건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  차이
                </FlexLayout>
              </FlexLayout>
            </FlexLayout>
          ),
          width: 150,
          render: (x) => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: 'var(--color-green)' }}
              >
                {x.predict11}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
              >
                {x.cnt11}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={x.gap11 === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {x.gap11}
              </FlexLayout>
            </FlexLayout>
          ),
          trail: () => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: '#00FF00' }}
              >
                {scope.state.predict11_tot}
              </FlexLayout>
              <FlexLayout isVertical={true}>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  {scope.state.cnt11_tot}
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="centger"
                  style={{ color: 'var(--color-violet)' }}
                >
                  {scope.state.acc11_tot}%
                </FlexLayout>
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={scope.state.gap11_tot === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {scope.state.gap11_tot}
              </FlexLayout>
            </FlexLayout>
          ),
        },
        {
          id: '12',
          text: (
            <FlexLayout isVertical={true}>
              <FlexLayout>
                12월
              </FlexLayout>

              <FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  예측건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  고장건수
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  차이
                </FlexLayout>
              </FlexLayout>
            </FlexLayout>
          ),
          width: 150,
          render: (x) => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: 'var(--color-green)' }}
              >
                {x.predict12}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
              >
                {x.cnt12}
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={x.gap12 === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {x.gap12}
              </FlexLayout>
            </FlexLayout>
          ),
          trail: () => (
            <FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: '#00FF00' }}
              >
                {scope.state.predict12_tot}
              </FlexLayout>
              <FlexLayout isVertical={true}>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  {scope.state.cnt12_tot}
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="centger"
                  style={{ color: 'var(--color-violet)' }}
                >
                  {scope.state.acc12_tot}%
                </FlexLayout>
              </FlexLayout>
              <FlexLayout
                justify="center"
                align="center"
                style={scope.state.gap12_tot === '0' ? { color: 'var(--color-blue)' } : { color: 'var(--color-red)' }}
              >
                {scope.state.gap12_tot}
              </FlexLayout>
            </FlexLayout>
          ),
        },
      ]}
      rowHeight={Global.LAYOUT_GRID_HEIGHT_1}
      data={scope.state.breakMonthList}
    elGrid="breakMonthList"
    >
    </GridLayout>
  </FlexLayout>
);
